export default "__VITE_ASSET__3Z2tlO3E__"